import { render, staticRenderFns } from "./ElementDrag.vue?vue&type=template&id=987a3f56&scoped=true"
import script from "./ElementDrag.vue?vue&type=script&lang=js"
export * from "./ElementDrag.vue?vue&type=script&lang=js"
import style0 from "./ElementDrag.vue?vue&type=style&index=0&id=987a3f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987a3f56",
  null
  
)

export default component.exports